import { createRootDispatcher } from 'shisell';
import { createScoped, withIdentities, withMeta } from 'shisell/extenders';

import { getUserBrowser } from '@automation-suite/shared-clients-user-browser';

import { writer } from './writer';

export const dispatcher = createRootDispatcher((event) => writer({ ...event, Name: event.Name }))
  .extend(createScoped('SIMPLR_CHAT'))
  .extend(
    withIdentities({
      SessionId: getUserBrowser().SessionId,
      UserBrowserId: getUserBrowser().Id,
    })
  )
  .extend(withMeta('IsTest', process.env.NX_PUBLIC_APP_ENV !== 'production'))
  .extend(withMeta('sendToOpenSearch', process.env.NX_PUBLIC_APP_ENV === 'production'));
